import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(`¡Bienvenido a FiPer, ${res.user.name}!`);
      navigate("/", { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="fp-shell fp-grain" data-testid="register-screen">
      <div className="relative z-10 px-6 pt-10 pb-10 min-h-screen flex flex-col">
        <Link
          to="/welcome"
          data-testid="register-back-link"
          className="inline-flex items-center gap-1 text-soft hover:text-ink text-sm w-fit"
        >
          <ArrowLeft size={16} /> Volver
        </Link>

        <div className="mt-12 animate-fade-up">
          <img
            src="/branding/logo-horizontal-400.png"
            srcSet="/branding/logo-horizontal-400.png 1x, /branding/logo-horizontal-800.png 2x"
            alt="FiPer"
            width="106"
            height="60"
            className="h-10 w-auto mb-5 select-none"
            data-testid="register-brand-logo"
            draggable="false"
          />
          <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight">
            Empieza a ver<br />tu dinero real.
          </h1>
          <p className="mt-2 text-muted2">Crea tu cuenta gratuita en segundos.</p>
        </div>

        <form onSubmit={handleSubmit} className="mt-10 space-y-6 flex-1">
          <Field
            testid="register-name-input"
            label="Nombre"
            value={name}
            onChange={setName}
            placeholder="Tu nombre"
            required
          />
          <Field
            testid="register-email-input"
            label="Email"
            type="email"
            value={email}
            onChange={setEmail}
            placeholder="tu@correo.com"
            required
          />
          <Field
            testid="register-password-input"
            label="Contraseña"
            type="password"
            value={password}
            onChange={setPassword}
            placeholder="Mínimo 6 caracteres"
            required
          />

          {error && (
            <p data-testid="register-error" className="text-sm text-clay bg-clay/5 border border-clay/20 rounded-xl px-3 py-2">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit-button"
            className="w-full bg-sage-900 text-bone rounded-2xl py-4 font-bold hover:bg-sage-900/90 active:scale-[0.98] transition-all disabled:opacity-60"
          >
            {loading ? "Creando cuenta…" : "Crear cuenta"}
          </button>
        </form>

        <p className="text-center text-sm text-muted2 mt-6">
          ¿Ya tienes cuenta?{" "}
          <Link to="/login" data-testid="register-go-login" className="text-sage-900 font-bold">
            Inicia sesión
          </Link>
        </p>
      </div>
    </div>
  );
}

function Field({ label, testid, type = "text", value, onChange, placeholder, required }) {
  return (
    <div>
      <label className="text-[10px] font-bold uppercase tracking-[0.16em] text-sage-700 block mb-1">
        {label}
      </label>
      <input
        data-testid={testid}
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-transparent border-b-2 border-line py-3 text-lg outline-none focus:border-sage-500 transition-colors"
      />
    </div>
  );
}
